module.exports = __webpack_public_path__ + "static/media/doc.8614a7b3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/PDFFiles/doc.pdf
// module id = 2579
// module chunks = 1